<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="introduction">
<h1>Introduction</h1>
<p>Barry Robert Hale, born 19<sup>th</sup> October 1948, (Chester City Hospital) first son of Gordon Hale and Elsie Hale, nee Rowland, (third child).</p>
<p>Grew up in my early years at Edge, Nr Malpas, Cheshire, moving to Sunnyside, Malpas in 1953 with my brother Christopher and sister Marilyn.</p>
<p>I was the third child to my mother as she had Geoffrey and Sylvia.</p>
<p>As I grew up, I was not a confident child, quite shy in my early years which only left me when I left school and started work.</p>
<p>As I grew up there were to be more siblings, ten of us and I was the third oldest, Geoffrey, Sylvia, Me, Christopher, Marilyn, Malcolm, Wendy, Tim, Jonathan and Robin.</p>
<p>This is about me, from 1948–2021, my family gets mentioned as and when, they will not agree about everything.</p>
<p>Well, here I am, 72 years young, a bit different from the early hours of 19<sup>th</sup> October 1948, about 12.30 am when I came into this world, the first son/child of Gordon and Elsie Hale.</p>
<p>Well, I will try and tell it as I remember but some of my siblings will tell you differently, here goes.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?11e82e53